import Vue from 'vue'
import Vuex from 'vuex'
import decode from 'jwt-decode'
import router from '../router/index'
import createPersistedState from 'vuex-persistedstate'
import VueTippy, { TippyComponent } from "vue-tippy"; //tooltip
Vue.use(VueTippy); //use tooltip
Vue.component("tippy", TippyComponent); //use component

Vue.use(Vuex)

export default new Vuex.Store({

  state: {

    token: null,
    usuario: null,
    combustibleOrdenTip: 0,

  },

  getters: {
    getToken(state) {
      return state.token
    },
    getUsuario(state) {
      return state.usuario?.nombre ?? ''
    },
    getUser(state) {
      return state.usuario?.usuario ?? ''
    },
    getIdUsuario(state) {
      return Number(state.usuario?.idusuario) ?? 0
    },
    getPermisos(state) {
      return state.usuario?.permiso_empleado ?? ''
    },
    getPermisoCmb(state) {
      return state.usuario?.permiso_combustible ?? ''
    },
    getPermisoCmp(state) {
      return state.usuario?.permiso_comprobante ?? ''
    },
    getPermisoRp(state) {
      return state.usuario?.permiso_reporte ?? ''
    },
    getRol(state) {
      return state.usuario?.rol ?? ''
    },
    getRolPer(state) {
      return state.usuario?.rol_per ?? ''
    },
    getVentanasAcceso(state) {
      return state.usuario?.ventanasAcceso ?? ''
    },
    isExpired(state) {
      const exp = (state.usuario.exp * 1000)
      const now = Date.now()

      return now >= Number(exp) ? true : false
    },
  },

  mutations: {
    setToken(state,token){
      state.token = token
    },
    setUsuario(state,usuario){
      state.usuario = usuario
    },

    setCombustibleOrdenTip(state, value){
      state.combustibleOrdenTip = value
    }

  },

  actions: {
    guardarToken({commit},token){
      commit("setToken", token)
      commit("setUsuario", decode(token))
      // localStorage.setItem("token", token)
    },

    autoLogin({commit}, redirectTo = null){
      let token = this.getters.getToken

      if(token != null){

        if(token){

          commit("setToken", token);
          commit("setUsuario", decode(token));

        }

      }

      if (redirectTo) {
        let route;
        const [y, path, x] = redirectTo.split('/')
        route = router.resolve({ path: redirectTo })
        router.push({ name: route.route.name })
      } else {
        router.push({ name: 'home' })
      }
    },

    salir({commit}){
      commit("setToken", null)
      commit("setUsuario", null)
      localStorage.removeItem("token")
      router.push({name: 'login'})
      router.go(0);
    },
  },

  plugins: [
    createPersistedState({
      key: 'store_cmb',
      paths: ['token', 'usuario']
    })
  ],

  modules: {
  }
})
